<template>
    <div class="cursor-pointer w-100 overflow-hidden d-md-none justify-content-center align-items-center mb-3" style="border-radius: 10px;">
        <template v-if="isDisplayPlaceholders">
            <PlaceholderBox :minHeight="'120px'" />
        </template>
        <template v-else>
            <img
                @click="$emit('plusInfosClick')"
                :src="src" alt="prestation-image"
                style="height: auto; width: 100%;"
            >
        </template>
    </div>
</template>

<script>
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"

export default {
    name: "PictureMobile",
    props: {
        src: String,
        isDisplayPlaceholders: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        PlaceholderBox
    },
}
</script>


<style scoped>
    img {
        object-fit: cover;
        background: gray;
        max-height: 200px;
    }
</style>
